import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./VendorKnowledge.module.css";

const CorpusSources = () => {
  const { corpusId } = useParams();
  const navigate = useNavigate();
  const [sources, setSources] = useState([]);
  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  // Fetch sources on component mount
  useEffect(() => {
    fetchSources();
  }, [corpusId]);

  const fetchSources = async () => {
    try {
      const response = await axios.get(
        `https://prod.toxboxai.com/api/vendorknowledge/get-sources/${corpusId}`
      );
      setSources(response.data.sources.results || []);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to fetch sources");
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type !== "application/pdf") {
      setError("Please select a valid PDF file");
      setFile(null);
      return;
    }
    setFile(selectedFile);
    setStatus("");
    setError("");
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a PDF file");
      return;
    }
    if (!name || !description) {
      setError("Please provide both name and description");
      return;
    }

    setIsLoading(true);
    setError("");
    setStatus("");

    const formData = new FormData();
    formData.append("pdf", file);
    formData.append("name", name);
    formData.append("description", description);
    formData.append("corpusId", corpusId);

    try {
      const response = await axios.post(
        "https://prod.toxboxai.com/api/vendorknowledge/upload-pdf-with-corpus",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setStatus(
        `PDF uploaded successfully! Document ID: ${response.data.documentId}, S3 URL: ${response.data.s3Url}`
      );
      setFile(null);
      setName("");
      setDescription("");
      setShowUploadModal(false);
      await fetchSources(); // Refresh sources list
    } catch (err) {
      setError(err.response?.data?.error || "Failed to upload PDF");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <button
            className={styles.createBtn}
            onClick={() => setShowUploadModal(true)}
          >
            Create new source
          </button>
          <button className={styles.exportBtn} onClick={() => navigate("/rag")}>
            Back to Knowledge Bases
          </button>
        </div>
      </div>

      {showUploadModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <div className={styles.modalHeader}>
              <h2>Upload to Corpus ID: {corpusId}</h2>
              <button
                className={styles.closeBtn}
                onClick={() => setShowUploadModal(false)}
              >
                ×
              </button>
            </div>
            <div className={styles.form}>
              <div className={styles.formGroup}>
                <label>Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Source Name"
                />
              </div>
              <div className={styles.formGroup}>
                <label>Description</label>
                <input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Source Description"
                />
              </div>
              <div className={styles.formGroup}>
                <label>Upload PDF</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                />
              </div>
              {error && <div className={styles.error}>{error}</div>}
              {status && <div className={styles.success}>{status}</div>}
              <div className={styles.formActions}>
                <button onClick={() => setShowUploadModal(false)}>
                  Cancel
                </button>
                <button
                  onClick={handleUpload}
                  disabled={isLoading || !file || !name || !description}
                >
                  {isLoading ? "Uploading..." : "Upload PDF"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={styles.cardContainer}>
        {sources.length > 0 ? (
          sources.map((source) => (
            <div key={source.sourceId} className={styles.card}>
              <div className={styles.cardHeader}>
                <h3>{source.name}</h3>
                <span className={styles.typeBadge}>{source.stats.status}</span>
              </div>
              <div className={styles.cardBody}>
                {/* <p>
                  <strong>Source ID:</strong> {source.sourceId}
                </p> */}
                <p>
                  <strong>Description:</strong> {source.description}
                </p>
                <p>
                  <strong>Total Documents:</strong> {source.stats.numDocs}
                </p>
                {/* <p>
                  <strong>Created:</strong> {new Date(source.created).toLocaleString()}
                </p> */}
                {/* <p>
                  {/* <strong>Last Updated:</strong> {new Date(source.stats.lastUpdated).toLocaleString()} */}
                {/* </p> */}
                {/* <p>
                  <strong>Document IDs:</strong> {source.upload?.documentIds?.join(', ') || 'N/A'}
                </p> */}
              </div>
              <div className={styles.cardFooter}>
                {/* Placeholder for future actions */}
              </div>
            </div>
          ))
        ) : (
          <p className={styles.noData}>No sources found.</p>
        )}
      </div>
    </div>
  );
};

export default CorpusSources;
